import { useMemo } from "react";
import { QuestionSlice } from "../../../../Redux/reducers/responseSlice";

type Props = {
  currentQuestion: any;
};

const ColStyle: any = {
  width: "100px",
  textAlign: "center",
  height: "35px",
  border: "1px solid black",
};

type AggregateProps = {
  currentQuestion: QuestionSlice;
  index: number;
  type: "row" | "column";
  aggregateType: string;
};
const AggregateField: React.FC<AggregateProps> = ({
  currentQuestion,
  index,
  type,
  aggregateType,
}) => {
  const { responses } = currentQuestion;
  const currentResponse =
    responses?.[0]?.aggregateData?.[type]?.[index]?.numberValue ?? 0;
  return (
    <>
      {aggregateType} : {currentResponse}
    </>
  );
};

const RepeatedField = ({ currentQuestion }: Props) => {
  const { properties, responses } = currentQuestion;
  const repeatedConfig = properties?.repeatedConfig.columns;

  const rowAggregate = properties?.repeatedConfig.rowAggregate;
  const columnAggregate = useMemo(() => {
    return repeatedConfig.some((col: any) => !!col.aggregateType);
  }, [repeatedConfig]);

  const currentResArray = responses?.[0]?.repeatedData;

  return (
    <>
      <table>
        <thead>
          <tr>
            <td> Row No</td>
            {repeatedConfig?.map((col: any, i: number) => (
              <td style={{ textAlign: "center" }} key={i}>
                {col.label}
              </td>
            ))}
            {rowAggregate && (
              <td style={{ textAlign: "center", textTransform: "capitalize" }}>
                {rowAggregate}
              </td>
            )}
          </tr>
        </thead>
        <tbody>
          {currentResArray.map((_: any, i: number) => (
            <tr key={i}>
              <td style={{ minWidth: "85px", textAlign: "center" }}>{i + 1}</td>
              {repeatedConfig?.map((col: any, j: number) => (
                <td style={ColStyle} key={j}>
                  {responses?.[0]?.repeatedData?.[i]?.[j]?.[
                    col?.type === "number" ? "numberValue" : "textValue"
                  ] || ""}
                </td>
              ))}
              {rowAggregate && (
                <td style={{ textAlign: "center" }}>
                  <AggregateField
                    currentQuestion={currentQuestion}
                    index={i}
                    type={"row"}
                    aggregateType={rowAggregate}
                  />
                </td>
              )}
            </tr>
          ))}
          {columnAggregate && (
            <tr key={"col-aggregate"}>
              <td style={{ textAlign: "center" }}>Aggregate</td>
              {repeatedConfig?.map((col: any, j: number) => (
                <td style={{ textAlign: "center" }} key={j}>
                  {col.aggregateType ? (
                    <AggregateField
                      currentQuestion={currentQuestion}
                      index={j}
                      type={"column"}
                      aggregateType={col?.aggregateType}
                    />
                  ) : (
                    "-"
                  )}
                </td>
              ))}
              {rowAggregate && <td></td>}
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default RepeatedField;
